import React from "react";
import $ from "jquery";
import { marked } from "marked";
import { Helmet } from "react-helmet";

function test(project_title, project_desc, project_git, project_report, project_package, project_date, project_techs)
{
    console.log(marked.parse(project_desc))
    $(".desc").html(
        "<div class='card' id='desc'>"
        + "<div class='card-body'>"
        + "<h6 class='card-title'>" + project_title + "</h6>"
        + "<hr class='col-3 col-md-2 mb-4'/>"
        + "<p class='card-text'>" + marked.parse(project_desc) + "</p>"
        + "<hr class='col-3 col-md-6 mb-2'/>"
        + "<p>R&D period : <b>" + project_date + "</b><br>"
        + "Involved techs : <b>" + project_techs + "</b></p>"
        + ((project_report === "-1") ? "" : "<a target='_BLANK' href='" + project_report + "' class='btn btn-danger'>Report</a>" + "&nbsp;&nbsp;")
        + ((project_git === "-1") ? "" : "<a target='_BLANK' href='" + project_git + "' class='btn btn-primary'>GitHub repo</a>" + "&nbsp;&nbsp;")
        + ((project_package === "-1") ? "" : "<a target='_BLANK' href='" + project_package + "' class='btn btn-success'>Official package</a>")

        + "</div></div>"
    )
}

function Projects()
{
    var request = new XMLHttpRequest();
    request.open("GET", "data/projects.json", false);
    request.send(null);
    var json = JSON.parse(request.responseText);

    const elts = Object.values(json);
    console.log(elts.length)
    return (
        <div>
            <Helmet>
                <title>Projects | Lucas RODRIGUEZ</title>
            </Helmet>
            <h2>Projects</h2>
            <p>For more details (description, GitHub repo, slides, ...), click on the project title.</p>

            {/* <p>
                <a className="btn btn-sm btn-outline-dark" href="resume/projects.pdf">
                    Projects summary &bull; <i>PDF</i>
                </a>
            </p> */}



            <small>
                <span className="badge rounded-pill bg-danger">A</span> : Academic
                &middot; <span className="badge rounded-pill bg-success">P</span> : Personal
                &middot; <span className="badge rounded-pill bg-warning">P</span> : Professional
            </small>
            <small>
                &nbsp; ― &nbsp;Total : <b style={{ fontStyle: "italic" }}>{elts.length}</b> projects
            </small>
            <hr class="col-3 col-md-2 mb-4" />
            <div className="row">
                <div className="col-md-6">

                    <div class="list-group left-col-scroll">
                        {elts.map((value) =>
                        {
                            var project_title = value.project_title;
                            var project_desc = value.project_desc;
                            var project_git = value.project_git;
                            var project_report = value.project_report;
                            var project_type = value.project_type;
                            var project_date = value.project_date;
                            var project_techs = value.project_techs;
                            var project_package = value.project_package;
                            return <button
                                type="button"
                                class="list-group-item list-group-item-action "
                                onClick={() => test(project_title, project_desc, project_git, project_report, project_package, project_date, project_techs)}>
                                <div className="d-flex justify-content-between">
                                    <a href="#" style={{
                                        color: 'black', textDecoration: 'none'
                                    }}>{value.project_title}</a>
                                    {
                                        project_type === "A" && <span className="badge bg-danger">A</span>
                                    }
                                    {
                                        project_type === "P" && <span className="badge bg-success">P</span>
                                    }
                                    {
                                        project_type === "Pro" && <span className="badge bg-warning">P</span>
                                    }
                                </div>
                            </button>
                        })
                        }
                    </div>

                </div>
                <div className="col-md-6">
                    <div className="desc">
                    </div>
                </div>
            </div >
        </div >
    );

}
export default Projects;